import { render, staticRenderFns } from "./ProductDescriptionForm.vue?vue&type=template&id=27c79fd6&"
import script from "./ProductDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./ProductDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports